import type { EntityType } from "../../data/schema/SubstrateSearchRequest";
import type ItemTypesFilter from "owa-service/lib/contract/ItemTypesFilter";

export default function convertItemTypesToEntityType(itemTypes: ItemTypesFilter | undefined): EntityType {
    if (!itemTypes) {
        return "MailItems";
    }
    
    switch (itemTypes) {
        case "CalendarItems":
            return "Event";
        case "MailConversations":
            return "Conversation";
        case "MessageItems":
            return "Email";
        case "Files":
            return "File";
        case "MailItems":
        default:
            return "Message";
    }
}
